jQuery(document).ready(function($) {
  $('#quick-shop-modal').on('hidden.bs.modal', function () {
    $('.zoomContainer').css('z-index', '1');
    $('#top').removeClass('z-idx');
  })

  $('#quick-shop-modal').on( 'shown.bs.modal', function () {
    $('#top').addClass('z-idx');
    
    imagesLoaded( '#quick-shop-modal', function() {
      
      $("#gallery_main_qs").show().owlCarousel({
        navigation : true,
        pagination: false,
        items: 1,
        itemsDesktop : [1199,1],
        itemsDesktopSmall : [979,1],
        itemsTablet: [768,1],
        itemsMobile : [479,1],
        scrollPerPage: true,
        navigationText: ['<i class="fa fa-angle-left" title="Previous"></i>', '<i class="fa fa-angle-right" title="Next"></i>']
      });
      
      var delayLoadingQS = '';       
      delayLoadingQS = setInterval(function(){            
        
        quickShopModalBackground.hide();
        $('.zoomContainer').css('z-index', '2000');
        $('#quick-shop-modal .modal-body').resize(); 
        
        clearInterval( delayLoadingQS );            
      }, 500);
    });
    
  });

  var quickShopModal = $('#quick-shop-modal');
  var quickShopSellable = $('#quick-shop-sellable');
  var quickShopQuotable = $('#quick-shop-quotable');
  var quickShopImage = $('#quick-shop-image');
  var quickShopTitle = $('#quick-shop-title');
  var quickShopDescription = $('.description', quickShopModal);
  var quickShopVariantsContainer = $('#quick-shop-variants-container');
  var quickShopPriceContainer = $('#quick-shop-price-container');
  var quickShopQtyWrapper = $('#quick-shop-qty-wrapper');
  var quickShopAddToCartButton = $('#quick-shop-add');
  var quickShopPlaceCustomOrderButton = $('#quick-shop-order');
  var quickShopProductActions = $('#quick-shop-product-actions');
  var quickShopModalBackground = $('#quick-shop-modal .quick-shop-modal-bg');
  var quoteRequestForm;

  var catalogMode = "yes";
  
  $('body').on(clickEv, '.quick_shop:not(.unavailable)', function(e) {
    if (!quoteRequestForm) {
      quoteRequestForm = new QuoteRequestForm($('#request-quote-form form'));
    }
    
    // Grab product data
    var productJson = $(this).parents('.element').find('.product-json').html();
    var productData = JSON.parse(productJson);
    productData.url = $(this).data('product-url');
    
    drawQuickShop(productData);
  });
  
  $('body').on(clickEv, '.request-quote-link.triggers-quick-shop', function(e) {
    e.preventDefault();
    
    if (!quoteRequestForm) {
      quoteRequestForm = new QuoteRequestForm($('#request-quote-form form'));
    }
    
    // Grab product data
    var productJson = $(this).parents('.element').find('.product-json').html();
    var productData = JSON.parse(productJson);
    
    drawQuickShop(productData, '#request-quote-form');
  });
  
  var drawQuickShop = function(selectedProduct, selectedTab) {
    var selectedProductID = selectedProduct.id;
    
    // The right part of the quick shop popup is different
    // depending on whether the product is sellable or not
    // (i.e. has price). Here we figure out what to show.
    
    if (selectedProduct.price != 0) {
      quickShopSellable.show();
      quickShopQuotable.hide();
    } else {
      quickShopSellable.hide();
      quickShopQuotable.show();
    }
    
    // Select tab or reset tab area
    if (typeof selectedTab != 'undefined') {
      $('.nav-tabs a[href="' + selectedTab +'"]', quickShopQuotable).tab('show');
    } else {
      $('.nav-tabs a:first', quickShopQuotable).tab('show');
    }
    
    // Update custom order button
    quickShopPlaceCustomOrderButton.attr('href', selectedProduct.url + '#tab-comanda');
    
    // Update add button
    quickShopAddToCartButton.data('product-id', selectedProductID);
    
    // Update image
    quickShopImage.empty();

    quickShopImage.append('<div id="gallery_main_qs" class="product-image-thumb scroll scroll-mini"></div>');
      
    var qs_images = selectedProduct.images;
    $.each(qs_images, function(index, value) {
      if(index)
        quickShopImage.find('#gallery_main_qs').append('<a class="image-thumb" onclick="return false" alt=""><img src="'+ Shopify.resizeImage(value, "large") +'" alt="" /></a>');
      else
        quickShopImage.find('#gallery_main_qs').append('<a class="image-thumb" onclick="return false" alt=""><img src="'+ Shopify.resizeImage(value, "large") +'" alt="" /></a>');
    });

    // Update title
    quickShopTitle.html('<a href="/products/' + selectedProduct.handle + '">' + selectedProduct.title + '</a>');
    $('.quote-title', quickShopModal).html(selectedProduct.title);

    // Update description
    quickShopDescription.html(selectedProduct.description);

    // Hide quantity selector for fireplace products
    if (catalogMode == 'no') {
      if (selectedProduct.type == 'Fireplace') {
        quickShopQtyWrapper.hide();
      } else {
        quickShopQtyWrapper.show();
      }
    }
    
    $('#quick-shop-request-quote').click(function() {
      $('.quick-shop-tabs a[href="#request-quote-form"]').tab('show');
    });
    
    // Reset quote request form
    quoteRequestForm.reset();
    quoteRequestForm.setProductId(selectedProductID);

    // Generate variants
    var productVariants = selectedProduct.variants;
    var productVariantsCount = productVariants.length;

    quickShopPriceContainer.html('');
    quickShopVariantsContainer.html('');
    quickShopAddToCartButton.removeAttr('disabled').fadeTo(200,1);

    if (productVariantsCount > 1) {

      // Reveal variants container
      quickShopVariantsContainer.show();

      // Build variants element
      var quickShopVariantElement = $('<select>',{ 'id': ('#quick-shop-variants-' + selectedProductID) , 'name': 'id'});
      var quickShopVariantOptions = '';

      for (var i=0; i < productVariantsCount; i++) {
        quickShopVariantOptions += '<option value="'+ productVariants[i].id +'">'+ productVariants[i].title +'</option>'
      };

      // Add variants element to page
      quickShopVariantElement.append(quickShopVariantOptions);
      quickShopVariantsContainer.append(quickShopVariantElement);

      // Bind variants to OptionSelect JS
      new Shopify.OptionSelectors(('#quick-shop-variants-' + selectedProductID), { product: selectedProduct, onVariantSelected: selectOptionCallback });

      // Add label if only one product option and it isn't 'Title'.
      if (selectedProduct.options.length == 1 && selectedProduct.options[0] != 'Title' ){
        $('#quick-shop-product-actions .selector-wrapper:eq(0)').prepend('<label>'+ selectedProduct.options[0] +'</label>');
      }

      // Auto-select first available variant on page load.
      var found_one_in_stock = false;
      for (var i=0; i < selectedProduct.variants.length; i++) {

        var variant = selectedProduct.variants[i];
        if(variant.available && found_one_in_stock == false) {

          found_one_in_stock = true;
          for (var j=0; j < variant.options.length; j++){

            $('.single-option-selector:eq('+ j +')').val(variant.options[j]).trigger('change');

          }
        }
      }

      $('#quick-shop-variants-container .single-option-selector').customStyle();

    } else { // If product only has a single variant

      // Hide unnecessary variants container
      quickShopVariantsContainer.hide(); 

      // Build variants element
      var quickShopVariantElement = $('<select>',{ 'id': ('#quick-shop-variants-' + selectedProductID) , 'name': 'id'});
      var quickShopVariantOptions = '';

      for (var i=0; i < productVariantsCount; i++) {
        quickShopVariantOptions += '<option value="'+ productVariants[i].id +'">'+ productVariants[i].title +'</option>'
      };

      // Add variants element to page
      quickShopVariantElement.append(quickShopVariantOptions);
      quickShopVariantsContainer.append(quickShopVariantElement);


      // Update the add button to include correct variant id
      quickShopAddToCartButton.data('variant-id', productVariants[0].id);

      // Determine if product is on sale
      if ( productVariants[0].compare_at_price > 0 && productVariants[0].compare_at_price > productVariants[0].price ) {
        quickShopPriceContainer.html('<span class="price_sale">'+ Shopify.formatMoney(productVariants[0].price, dataLayer.moneyFormat) +'</span>' + '<del class="price_compare">'+ Shopify.formatMoney(productVariants[0].compare_at_price, dataLayer.moneyFormat) + '</del>');
      } else {
        quickShopPriceContainer.html('<span class="price">'+ Shopify.formatMoney(productVariants[0].price, dataLayer.moneyFormat) + '</span>' );
      }

    } // END of (productVariantsCount > 1)

    
  };
         
  /* selectOptionCallback
  ===================================== */
  var selectOptionCallback = function(variant, selector) {
    // selected a valid and in stock variant
    if (variant && (variant.inventory_quantity > 0 || (variant.inventory_quantity <= 0 && variant.inventory_policy == 'continue'))) {
      quickShopAddToCartButton.data('variant-id', variant.id);

      if ($.browser.msie) {
        quickShopAddToCartButton.removeAttr('disabled').show(); 
      } else {
        quickShopAddToCartButton.removeAttr('disabled').fadeTo(200,1); 
      }

      // determine if variant is on sale
      if ( variant.compare_at_price > 0 && variant.compare_at_price > variant.price ) {
        quickShopPriceContainer.html('<span class="price_sale">'+ Shopify.formatMoney(variant.price, dataLayer.moneyFormat) + '</span>' + '<del class="price_compare">'+ Shopify.formatMoney(variant.compare_at_price, dataLayer.moneyFormat) + '</del>');
      } else {
        quickShopPriceContainer.html('<span class="price">'+ Shopify.formatMoney(variant.price, dataLayer.moneyFormat) + '</span>');
      }

    // selected an invalid or out of stock variant 
    } else {

      // variant doesn't exist
      if ($.browser.msie) {
        quickShopAddToCartButton.attr('disabled', 'disabled').hide(); 
      } else {
        quickShopAddToCartButton.attr('disabled', 'disabled').fadeTo(200,0.5);
      }

      var message = variant ? "Stoc epuizat" : "Produs nedisponibil";    
      quickShopPriceContainer.html('<span class="unavailable">' + message + '</span>');
    }

    
  }
        
});